import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { SharedService } from 'src/app/Shared/shared-service.service';

interface ICChangeHistory {
  changed_by: string,
  customerId: number,
  date: Date,
  newIC: string,
  oldIC: string
}

@Component({
    selector: 'app-ic-change-history',
    templateUrl: './ic-change-history.component.html',
    styleUrls: ['./ic-change-history.component.scss'],
    standalone: false
})
export class IcChangeHistoryComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);



  @Input() customerId: number;
  historyList: ICChangeHistory[] = [];

  ngOnInit(): void {
    this.getCustomerEpfChangeHistory(this.customerId)
  }

  getCustomerEpfChangeHistory(customerId: number) {
    const xhttp = this.restApi.getRequest(this.constructApi.getCustomerICChangeHistory(this.customerId))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {

        const jsonArray = JSON.parse(xhttp.responseText);
        jsonArray.forEach(json => {

          const history = { customerId: json.customerId, changed_by: json.changed_by, date: json.date, newIC: json.newIC, oldIC: json.oldIC };

          this.historyList.push(history);
        }
        );
      }
    };
  }


  reset() {
    this.activeModal.close();
  }
}
